/**
 * @generated SignedSource<<b9634cb0d7de1dc1f54b36b87c6d7224>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type communityShell_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"portals_user">;
  readonly " $fragmentType": "communityShell_user";
};
export type communityShell_user$key = {
  readonly " $data"?: communityShell_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"communityShell_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "slug"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "communityShell_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "club",
          "variableName": "slug"
        }
      ],
      "kind": "FragmentSpread",
      "name": "portals_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "fa5bdcfe9596b6636166a3a5dddbef7f";

export default node;
